import styled from 'styled-components';
import InfoIcon from './svg-icons/InfoIcon';
import { ReactNode } from 'react';

interface ChildProps {
  id?: string;
  title: string;
  children: ReactNode;
}

const DescriptionBlock = ({ id, title, children }: ChildProps) => {
  return (
    <Container id={id} className="prevent-select">
      <h5>
        <InfoIcon />
        {title}
      </h5>
      {children}
    </Container>
  );
};

const Container = styled.div`
  background-color: ${props => props.theme.light.colors.white};
  padding: 16px 0;
  margin-top: 16px;
  border-radius: ${props => props.theme.borderRadius};
  color: ${props => props.theme.light.colors.black};
  display: flex;
  flex-direction: column;
  gap: 8px;
  h5 {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    font-size: ${props => props.theme.font.sizes.xxxl};
    font-family: materialBold;
    color: ${props => props.theme.light.colors.primaryBlue};
  }

  .title {
    font-size: ${props => props.theme.font.sizes.xl};
    font-family: materialBold;
    color: ${props => props.theme.light.colors.black};
  }
  p {
    font-size: ${props => props.theme.font.sizes.s};
    &.headline {
      font-size: ${props => props.theme.font.sizes.l};
      font-family: materialBold;
      margin-top: 8px;
    }
  }
  ul {
    list-style: inside;
    margin-inline-start: 16px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    li {
      font-family: materialMedium;
      font-size: ${props => props.theme.font.sizes.s};
    }
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    background-color: ${props => props.theme.light.colors.whitish};
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    padding: 16px;
  }
`;
export default DescriptionBlock;
